import type { OneTimeDiscountListItem } from '../../../services/billing';
import { formatMoneyDollars } from '../../../utils/money';
import { useEscapeKey } from '../../../hooks/useEscapeKey';

interface DeleteOneTimeDiscountModalProps {
    discount: OneTimeDiscountListItem;
    onConfirm: () => void;
    onClose: () => void;
    isPending: boolean;
}

export function DeleteOneTimeDiscountModal({
    discount,
    onConfirm,
    onClose,
    isPending
}: DeleteOneTimeDiscountModalProps) {
    useEscapeKey(onClose, !isPending);
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-[440px] p-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">Delete one-time discount</h2>
                <p className="text-sm text-gray-600">
                    Delete the {formatMoneyDollars(discount.amount)} one-time discount "
                    {discount.description}"?
                    {discount.sourceChargeId
                        ? ' Its source charge can generate a one-time discount again.'
                        : ''}{' '}
                    This cannot be undone.
                </p>
                <div className="flex justify-end items-center gap-3 mt-6">
                    <button
                        type="button"
                        onClick={onClose}
                        className="bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isPending}
                        className="bg-red-600 text-white rounded-lg px-4 py-2 text-sm font-semibold hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isPending ? 'Deleting…' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
}
